define('core/templates/postMediaPlaceholder',['handlebars', 'handlebars.partials', 'core/extensions/handlebars.helpers'], function(Handlebars) {

return Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "<a href=\"#\" class=\"media-force-load\" data-action=\"force-load\"><i class=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? depth0.model : depth0)) != null ? stack1.providerIcon : stack1), depth0))
    + "\"></i></a>\n";
},"useData":true})

});
